import { useEffect } from "react";

type AutosaveOpts = {
  structureId?: string;
  viewOnly: boolean;
  dirty: boolean;
  dirtyTick: number;
  persist: () => void;
  delay?: number;
};

export function useAutosave({ structureId, viewOnly, dirty, dirtyTick, persist, delay = 1200 }: AutosaveOpts) {
  useEffect(() => {
    if (!structureId || viewOnly || !dirty) return;
    const handle = window.setTimeout(() => {
      persist();
    }, delay);
    return () => window.clearTimeout(handle);
  }, [structureId, viewOnly, dirty, dirtyTick, persist, delay]);
}
